import React, { Component, useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { Row, Affix, Avatar, Col, Icon, Menu, Drawer, Button } from 'antd';
import Zoom from 'react-reveal/Zoom';
import Slide from 'react-reveal/Slide';
import Flip from 'react-reveal/Flip';
import Calculator from '../common/tools/calculator/index';
import { AuthContext } from '../../context/auth';
import { set } from 'react-hook-form';
const { SubMenu } = Menu;

function callback(key) {
    console.log(key);
}

function MyMenu(theMode) {
    const { user } = useContext(AuthContext);

    const mode = theMode.theMode;
    return (
        <Menu mode={mode}>
            <Menu.Item key="1">
                <Link to={'/'}>

                    <span className="submenu-title-wrapper">
                        <Icon type="home" />
                        خانه
                    </span>

                </Link>
            </Menu.Item>
            <SubMenu
                title={
                    <span className="submenu-title-wrapper">
                        <Icon type="build" />
                        خدمات
                    </span>
                }
            >
                <Menu.Item key="31">
                    <Link to="/dashboard/reserve-time" >

                        <span className="submenu-title-wrapper">
                            نوبت‌دهی آنلاین
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="33">
                    <Link to="/sana-transfer" >

                        <span className="submenu-title-wrapper">
                            حواله سنا
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="34">
                    <Link to="/nima-transfer" >

                        <span className="submenu-title-wrapper">
                           حواله نیما
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="32">
                    <Link to="/forms" >

                        <span className="submenu-title-wrapper">
                            فرم ها
                        </span>

                    </Link>
                </Menu.Item>

               

                <Menu.Item key="35">
                    <Link to="/in-development" >

                        <span className="submenu-title-wrapper">
                            نمودار
                        </span>

                    </Link>
                </Menu.Item>


            </SubMenu>



            <SubMenu
                title={
                    <span className="submenu-title-wrapper">
                        <Icon type="dollar" />
                        لیست قیمت
                    </span>
                }
            >
                <Menu.Item key="21">
                    <Link to="/price-list/coin-rate" >

                        <span className="submenu-title-wrapper">
                            نرخ سکه
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="22">
                    <Link to="/price-list/exchange-rate">

                        <span className="submenu-title-wrapper">
                            نرخ ارز
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="23">
                    <Link to="/price-list/change-rate" >

                        <span className="submenu-title-wrapper">
                            نرخ برابری ارز
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="24">
                    <Link to="/price-list/transfer-rate" >

                        <span className="submenu-title-wrapper">
                            نرخ حواله
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="25">
                    <Link to="/price-list/ctyptocurrency-rate" >

                        <span className="submenu-title-wrapper">
                            نرخ ارز دیجیتال
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="26">
                    <Link to="/price-list/bank-rate" >

                        <span className="submenu-title-wrapper">
                            نرخ بانک‌مرکزی
                        </span>

                    </Link>
                </Menu.Item>

            </SubMenu>

            <SubMenu
                title={
                    <span className="submenu-title-wrapper">
                        <Icon type="file" />
                        بلاگ
                    </span>
                }
            >
                <Menu.Item key="71">
                    <a href="https://blog.bayatiexchange.com">

                        <span className="submenu-title-wrapper">
                            مقالات
                        </span>

                    </a>
                </Menu.Item>

                <Menu.Item key="72">
                    <Link to="/Announcements">

                        <span className="submenu-title-wrapper">
                            اطلاعیه‌ها
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="73">
                    <Link to="/economicNews" >

                        <span className="submenu-title-wrapper">
                            اخبار دنیای اقتصاد
                        </span>

                    </Link>
                </Menu.Item>

            </SubMenu>


            <SubMenu
                title={
                    <span className="submenu-title-wrapper">
                        <Icon type="info-circle" />
                        درباره‌ما
                    </span>
                }
            >
                <Menu.Item key="51">
                    <Link to="/contactUs" >

                        <span className="submenu-title-wrapper">
                            تماس با ما
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="52">
                    <Link to="/certificates" >

                        <span className="submenu-title-wrapper">
                            مجوز‌ها
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="53">
                    <Link to="/aboutUs" >

                        <span className="submenu-title-wrapper">
                            درباره‌ما
                        </span>

                    </Link>
                </Menu.Item>
                <Menu.Item key="54">
                    <Link to="/careers" >

                        <span className="submenu-title-wrapper">
                            همکاری‌با‌ما
                        </span>

                    </Link>
                </Menu.Item>


                <Menu.Item key="56">
                    <Link to="/FAQ" >

                        <span className="submenu-title-wrapper">
                            سوالات متداول
                        </span>

                    </Link>
                </Menu.Item>


                <Menu.Item key="57">
                    <Link to="/termsAndConditions" >

                        <span className="submenu-title-wrapper">
                            قوانین و مقررات
                        </span>

                    </Link>
                </Menu.Item>


            </SubMenu>

        </Menu>
    )
}

function DesktopMenu() {
    const { user } = useContext(AuthContext);
    const [calculatorShow, setCalculatorShow] = useState(false);

    return (
        <div className="headerWrapper">
            <div className="container headerContainer">
                <div className="header">
                    <div className="mainHeader">
                        <Slide left>
                            <div className="menuLeft">
                                <Row className="innerMainMenu">
                                    <Col span={8}>
                                        <div className="mainMenuItem">
                                            <div className="mainMenuItemInner">
                                                <p>بلاگ</p>
                                                <div>
                                                    <Icon type="double-right" />
                                                </div>
                                            </div>
                                            <div className="amirDropMenu">
                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={24}>
                                                            <a href={"https://blog.bayatiexchange.com"} className={"verticalHalfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="file-text" />
                                                                </div>
                                                                <p>مقالات</p>
                                                            </a>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Link to={"/Announcements"} className={"verticalHalfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="notification" />
                                                                </div>
                                                                <p>اطلاعیه‌ها</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Link to={"/economicNews"} className={"verticalHalfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="area-chart" />
                                                                </div>
                                                                <p>اخبار خبرگزاری‌ها</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>

                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mainMenuItem">
                                            <div className="mainMenuItemInner">
                                                <p>درباره ما</p>
                                                <div>
                                                    <Icon type="double-right" />
                                                </div>
                                            </div>
                                            <div className="amirDropMenu">
                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/contactUs"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="phone" />
                                                                </div>
                                                                <p>تماس با ما</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/certificates"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="safety-certificate" />
                                                                </div>
                                                                <p>مجوز‌ها</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/careers"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="usergroup-add" />
                                                                </div>
                                                                <p>همکاری‌با‌ما</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/aboutUs"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="team" />
                                                                </div>
                                                                <p>درباره‌ما</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>


                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/termsAndConditions"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="file-text" />
                                                                </div>
                                                                <p>قوانین</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/FAQ"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="question-circle" />
                                                                </div>
                                                                <p>سوالات متداول</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>

                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mainMenuItem">
                                            <div className="mainMenuItemInner">
                                                <p>پنل کاربری</p>
                                                <div>
                                                    <Icon type="double-right" />
                                                </div>
                                            </div>
                                            <div className="amirDropMenu">
                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={24}>
                                                            {
                                                                user === null ? (
                                                                    <div className="userDropDownSection">
                                                                        <div className={"userDropDownAvatar"}>
                                                                            <Avatar size={64} icon="user" />
                                                                        </div>
                                                                        <div className={"guestName"}>کاربر میهمان</div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="userDropDownSection">
                                                                        <div className={"guestName"}>{user.user.full_name}</div>
                                                                        <div className={"guestName"}>{'نام کاربری : ' + user.user.username}</div>
                                                                    </div>
                                                                )
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="amirDropMenuItem">
                                                    {
                                                        user === null ? (
                                                            <Row>
                                                                <Col span={12}>
                                                                    <Link to={"/login"} className={"halfDropMenuItem"}>
                                                                        <div className="halfDropMenuItemIcon">
                                                                            <Icon type="login" />
                                                                        </div>
                                                                        <p>ورود</p>
                                                                    </Link>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <Link to={"/sign-up"} className={"halfDropMenuItem"}>
                                                                        <div className="halfDropMenuItemIcon">
                                                                            <Icon type="user-add" />
                                                                        </div>
                                                                        <p>ثبت نام</p>
                                                                    </Link>
                                                                </Col>
                                                            </Row>
                                                        ) : (
                                                            <Row>
                                                                <Col span={12}>
                                                                    <Link to={"/logout"} className={"halfDropMenuItem"}>
                                                                        <div className="halfDropMenuItemIcon">
                                                                            <Icon type="logout" style={{ color: '#ff3333' }} />
                                                                        </div>
                                                                        <p style={{ color: '#ff3333' }}>خروج</p>
                                                                    </Link>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <Link to={"/dashboard"} className={"halfDropMenuItem"}>
                                                                        <div className="halfDropMenuItemIcon">
                                                                            <Icon type="menu" />
                                                                        </div>
                                                                        <p>پنل کاربری</p>
                                                                    </Link>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Slide>
                        <Zoom>
                            <div className="logoSection">

                                <div className="logoSectionInner">
                                    <Link to={"/"}>
                                        <img src={"../clientAssets/newLogo.png"} alt="" />
                                    </Link>
                                </div>

                            </div>
                        </Zoom>
                        <Slide right>
                            <div className="menuRight">
                                <Row className="innerMainMenu">
                                    <Col span={8}>
                                        <div className="mainMenuItem">
                                            <Link to={"/"} className="mainMenuItemInner">
                                                <p>خانه</p>
                                                <div className={"homeIconMenu"}>
                                                    <Icon type="home" />
                                                </div>
                                            </Link>
                                        </div>
                                    </Col>

                                    <Col span={8}>
                                        <div className="mainMenuItem">
                                            <div className="mainMenuItemInner">
                                                <p>خدمات</p>
                                                <div>
                                                    <Icon type="double-right" />
                                                </div>
                                            </div>
                                            <div className="amirDropMenu">
                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/dashboard/passenger-money"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="euro" />
                                                                </div>
                                                                <p>ارز مسافرتی</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/dashboard/reserve-time"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="cluster" />
                                                                </div>
                                                                <p>نوبت‌دهی</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/sana-transfer"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="global" />
                                                                </div>
                                                                <p>حواله سنایی</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/nima-transfer"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="deployment-unit" />
                                                                </div>
                                                                <p>حواله نیمایی</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/forms"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="form" />
                                                                </div>
                                                                <p>فرم ها</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>

                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mainMenuItem">
                                            <div className="mainMenuItemInner">
                                                <p>لیست قیمت</p>
                                                <div>
                                                    <Icon type="double-right" />
                                                </div>
                                            </div>
                                            <div className="amirDropMenu">
                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/price-list/exchange-rate"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="dollar" />
                                                                </div>
                                                                <p>نرخ ارز</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/price-list/coin-rate"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="gold" />
                                                                </div>
                                                                <p>نرخ سکه</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/price-list/transfer-rate"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="file-protect" />
                                                                </div>
                                                                <p>نرخ حواله</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/price-list/change-rate"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="retweet" />
                                                                </div>
                                                                <p>نرخ برابری ارز</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="amirDropMenuItem">
                                                    <Row>
                                                        <Col span={12}>
                                                            <Link to={"/price-list/bank-rate"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="profile" />
                                                                </div>
                                                                <p>نرخ بانک‌مرکزی</p>
                                                            </Link>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Link to={"/price-list/ctyptocurrency-rate"} className={"halfDropMenuItem"}>
                                                                <div className="halfDropMenuItemIcon">
                                                                    <Icon type="global" />
                                                                </div>
                                                                <p>ارزهای دیجیتال </p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                </Row>
                            </div>
                        </Slide>
                    </div>
                </div>
            </div>
            <div className={"headerAccesorriess"}>
                <div className="container">
                    <div className={"headerAccesorriessInner"}>
                        <Affix offsetTop={10}>
                            <div className="leftAccessories">
                                <div className={"leftAccssLeft"}>
                                    <div className="leftAccssLineCircle"></div>
                                    <div className="leftAccssLine"></div>
                                    <div className="leftAccssLineCircle"></div>
                                </div>
                                <div className={"leftAccssRight"}>
                                    {
                                        user === null ? (
                                            <>
                                                <Flip left>
                                                    <Link to={"/login"} className={"leftAccssItem"}>
                                                        <div className="leftAccssItemIcon">
                                                            <Icon type="login" />
                                                        </div>
                                                        <div className="leftAccssItemText">
                                                            <p>ورود</p>
                                                        </div>
                                                    </Link>
                                                </Flip>

                                                <Flip left>
                                                    <Link to={"/sign-up"} className={"leftAccssItem"}>
                                                        <div className="leftAccssItemIcon">
                                                            <Icon type="user-add" />
                                                        </div>
                                                        <div className="leftAccssItemText">
                                                            <p>ثبت‌نام</p>
                                                        </div>
                                                    </Link>
                                                </Flip>
                                            </>
                                        ) : (

                                            <Flip left>
                                                <Link to={"/dashboard"} className={"leftAccssItem"}>
                                                    <div className="leftAccssItemIcon">
                                                        <Icon type="appstore" />
                                                    </div>
                                                    <div className="leftAccssItemText">
                                                        <p>پنل کاربری</p>
                                                    </div>
                                                </Link>
                                            </Flip>

                                        )
                                    }


                                    <Flip left>
                                        <Link to={"/transfer-request"} className={"leftAccssItem"}>
                                            <div className="leftAccssItemIcon">
                                                <Icon type="swap" />
                                            </div>
                                            <div className="leftAccssItemText">
                                                <p>ارسال حواله</p>
                                            </div>
                                        </Link>
                                    </Flip>



                                    <Flip left>
                                        <Link to={"/dashboard/reserve-time"} className={"leftAccssItem"}>
                                            <div className="leftAccssItemIcon">
                                                <Icon type="cluster" />
                                            </div>
                                            <div className="leftAccssItemText">
                                                <p>سیستم نوبت‌دهی آنلاین</p>
                                            </div>
                                        </Link>
                                    </Flip>
                                    <Flip left>
                                        <Link to={"/contactUs"} className={"leftAccssItem"}>
                                            <div className="leftAccssItemIcon">
                                                <Icon type="phone" />
                                            </div>
                                            <div className="leftAccssItemText">
                                                <p>تماس با ما</p>
                                            </div>
                                        </Link>
                                    </Flip>

                                    <Flip left>
                                        <a href={"https://www.instagram.com/bayati.exchange/"} target={"_blank"} className={"leftAccssItem"}>
                                            <div className="leftAccssItemIcon">
                                                <Icon type="instagram" />
                                            </div>
                                            <div className="leftAccssItemText">
                                                <p>اینستاگرام</p>
                                            </div>
                                        </a>
                                    </Flip>


                                    <Flip left>
                                        <Link to={"/world-clock"} className={"leftAccssItem"}>
                                            <div className="leftAccssItemIcon">
                                                <Icon type="clock-circle" />
                                            </div>
                                            <div className="leftAccssItemText">
                                                <p>ساعت جهانی</p>
                                            </div>
                                        </Link>
                                    </Flip>
                                    {user === null ? (
                                        <></>
                                    ) : (
                                        <Flip left>
                                            <Link to={"/logout"} className={"leftAccssItem"}>
                                                <div className="leftAccssItemIcon">
                                                    <Icon type="logout" />
                                                </div>
                                                <div className="leftAccssItemText">
                                                    <p>خروج</p>
                                                </div>
                                            </Link>
                                        </Flip>
                                    )}

                                </div>
                            </div>
                        </Affix>
                    </div>
                </div>
            </div>
            <div className={"calcuratorWrapper"} style={{ display: calculatorShow ? 'block' : 'none' }}>
                <Calculator />
            </div>


        </div>
    )
}


export default function Header() {
    const { user } = useContext(AuthContext);
    const [drawerVisible, setDrawerVisible] = useState(false)

    return (
        <div>
            <DesktopMenu />
            <div className={'mobileMenuWrapper'}>
                <div className="mobileMenu">
                    <a onClick={() => {
                        setDrawerVisible(!drawerVisible);
                    }}>
                        <Icon type="menu" />
                    </a>
                    <Drawer
                        placement="right"
                        closable={true}
                        onClose={() => {
                            setDrawerVisible(!drawerVisible);

                            //console.log("drawer now is : ", this.state.drawerVisible)
                        }
                        }
                        visible={drawerVisible}
                    >
                        {
                            user === null ?
                                (
                                    <div className="home-drawer-top-button">
                                        <Link to={'/login'}>

                                            <span className="submenu-title-wrapper error">
                                                <Button type="default" block icon={'login'}>
                                                    ورود
                                                </Button>
                                            </span>

                                        </Link>
                                        <Link to={'/sign-up'}>

                                            <span className="submenu-title-wrapper error">
                                                <Button type="default" block icon={'user-add'}>
                                                    ثبت‌نام
                                                </Button>
                                            </span>

                                        </Link>
                                    </div>
                                ) : (
                                    <div className="home-drawer-top-button">
                                        <Link to={'/logout'}>

                                            <span className="submenu-title-wrapper error">
                                                <Button type="danger" block icon={'logout'}>
                                                    خروج
                                                </Button>
                                            </span>

                                        </Link>
                                        <Link to={'/dashboard'}>

                                            <span className="submenu-title-wrapper error">
                                                <Button type="default" block icon={'appstore'}>
                                                    داشبود
                                                </Button>
                                            </span>

                                        </Link>
                                    </div>
                                )
                        }
                        <MyMenu theMode={'inline'} />
                    </Drawer>
                </div>
            </div>
            <div className={'mobileMenuLogo'}>
                <img src={"../clientAssets/newLogo.png"} alt="" />
            </div>
        </div>

    )

}